import { render, staticRenderFns } from "./DataListSecurityQuestions.vue?vue&type=template&id=bf62814c&"
import script from "./DataListSecurityQuestions.vue?vue&type=script&lang=js&"
export * from "./DataListSecurityQuestions.vue?vue&type=script&lang=js&"
import style0 from "./DataListSecurityQuestions.vue?vue&type=style&index=0&id=bf62814c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports